import React from "react";
import PropTypes from "prop-types";
import { Stack } from "@mui/material";
import { TextView } from "../../../components";
import { colors } from "../../../utils";
import { styled } from "@mui/system";

// Styled Components
const TagWrapper = styled("div")(({ isSelected }) => ({
  border: `1px solid ${isSelected ? colors.PrimaryPurple : colors.lightGrey}`,
  backgroundColor: isSelected ? colors.PrimaryPurple : "transparent",
  padding: "6px 16px",
  borderRadius: "21px",
  cursor: "pointer",
  transition: "background-color 0.2s ease-in-out, border-color 0.2s ease-in-out",
}));

const Tag = ({ tag, isSelected, onClick }) => {
  return (
    <TagWrapper isSelected={isSelected} onClick={() => onClick(tag)}>
      <TextView color={isSelected ? "white" : "#123051"} variant="subtitle">
        {tag.name}
      </TextView>
    </TagWrapper>
  );
};

Tag.propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

// Main Component
export default function TagList({ tags, value, onSelect }) {
  return (
    <Stack
      sx={{ backgroundColor: colors.white }}
      direction="row"
      flexWrap="wrap"
      gap={1.4}
      alignItems="center"
      style={{ flex: 1, justifyContent: "center" }}
    >
      {tags.map((tag) => (
        <Tag key={tag.id} tag={tag} isSelected={value?.id === tag.id} onClick={onSelect} />
      ))}
    </Stack>
  );
}

TagList.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }),
  onSelect: PropTypes.func.isRequired,
};
